// DialogPopup.jsx
import React, { useRef } from "react";

export default function DialogPopup({ trigger, children, maxWidth = 500 }) {
  const dlgRef = useRef(null);

  const open = (e) => {
    e?.preventDefault();
    dlgRef.current?.showModal();
    document.documentElement.classList.add("modal-open");
  };
  const close = () => {
    dlgRef.current?.close();
    document.documentElement.classList.remove("modal-open");
  };
  const closeOnBackdrop = (e) => {
    if (e.target === dlgRef.current) close();
  };

   const childWithClose =
    React.isValidElement(children)
      ? React.cloneElement(children, { onSent: close })  // ⇦ ici
      : children;

  return (
    <>
      {React.cloneElement(trigger, { onClick: open })}
      <dialog
        ref={dlgRef}
        onClick={closeOnBackdrop}
        onClose={close}
        style={{ padding: 0, border: "none", background: "transparent" }}
      >
        <div
          style={{
            position: "relative",
            background: "#fff",
            padding: 24,
            borderRadius: 12,
            width: `min(92vw, ${maxWidth}px)`,
            maxHeight: "90vh",
            overflow: "auto",
            boxShadow: "0 10px 15px rgba(0,0,0,.1), 0 4px 6px rgba(0,0,0,.05)",
          }}
        >
          <button
            type="button"
            onClick={close}
            aria-label="Fermer"
            style={{
              position: "absolute", top: 8, right: 10, background: "transparent",
              border: 0, fontSize: 24, cursor: "pointer", lineHeight: 1,
            }}
          >
            ×
          </button>
          {childWithClose}
        </div>
      </dialog>
    </>
  );
}
